import { render, staticRenderFns } from "./decorator.vue?vue&type=template&id=d50af342"
import script from "./decorator.vue?vue&type=script&lang=js"
export * from "./decorator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports